import { Box, Button, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/config/app.config';
import { gradients } from '@/theme/theme';

export function CtaSection() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                py: { xs: 8, md: 12 },
                background: gradients.primary,
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            {/* Decorative circles */}
            <Box
                sx={{
                    position: 'absolute',
                    top: -100,
                    right: -100,
                    width: 400,
                    height: 400,
                    borderRadius: '50%',
                    bgcolor: 'rgba(255,255,255,0.05)',
                }}
            />
            <Box
                sx={{
                    position: 'absolute',
                    bottom: -60,
                    left: -60,
                    width: 250,
                    height: 250,
                    borderRadius: '50%',
                    bgcolor: 'rgba(255,255,255,0.05)',
                }}
            />

            <Container maxWidth="md" sx={{ position: 'relative', textAlign: 'center' }}>
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 700,
                        color: '#FFFFFF',
                        mb: 2,
                        fontSize: { xs: '1.8rem', md: '2.5rem' },
                    }}
                >
                    {t('landing.cta.title')}
                </Typography>
                <Typography
                    variant="h6"
                    sx={{
                        color: 'rgba(255,255,255,0.8)',
                        mb: 4,
                        fontWeight: 400,
                    }}
                >
                    {t('landing.cta.subtitle')}
                </Typography>
                <Button
                    variant="contained"
                    size="large"
                    onClick={() => navigate(ROUTES.register)}
                    sx={{
                        px: 5,
                        py: 1.5,
                        fontSize: '1.1rem',
                        fontWeight: 700,
                        borderRadius: 3,
                        bgcolor: '#1F2937',
                        color: '#FFFFFF',
                        background: 'none',
                        backgroundColor: '#1F2937',
                        '&:hover': {
                            backgroundColor: '#111827',
                        },
                        boxShadow: '0 4px 24px rgba(0,0,0,0.3)',
                    }}
                >
                    {t('landing.cta.button')}
                </Button>
            </Container>
        </Box>
    );
}

export default CtaSection;
